import type { JSX } from 'react'
import type { ITabProps } from '../Tab'

import { Tab } from '../Tab'
import { TabBorders, TabPaddings } from '../Tab.h'

export interface IBorderBottomTabProps extends ITabProps {}

export const BorderBottomTab = ({
  title = '',
  selected,
  borders = TabBorders.SIZE_20,
  paddings = TabPaddings.SIZE_10,
  ...rest
}: IBorderBottomTabProps): JSX.Element | null =>
  title ? (
    <Tab
      title={title}
      selected={selected}
      borders={borders}
      paddings={paddings}
      {...rest}
    />
  ) : null
